export const PAYMENT_MODES = [
  { id: "cash", label: "Cash", icon: "₹", typeOfPayment: "offline" },
  { id: "upi", label: "UPI", icon: "≡", typeOfPayment: "offline" },
  { id: "card", label: "Card", icon: "▮", typeOfPayment: "offline" },
  {
    id: "razorpayLink",
    label: "Razorpay Link (email)",
    icon: "➤",
    typeOfPayment: "online",
  },
];
